module.exports = __webpack_public_path__ + "img/cholesterol_meter_White.6548eb28.svg";